import { render, staticRenderFns } from "./ShowProperty.vue?vue&type=template&id=6635b25e&"
import script from "./ShowProperty.vue?vue&type=script&lang=js&"
export * from "./ShowProperty.vue?vue&type=script&lang=js&"
import style0 from "./ShowProperty.vue?vue&type=style&index=0&id=6635b25e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports